export default __webpack_public_path__ + "static/media/EM0730.34I-22032_-15022_0.8fddc523.jpg";